import { UCard } from '@x-tech/fe-puma-lib-ucard/dist/UCard';
import * as authHelper from '@/helper/auth';

export default {
    methods: {
        async $_regPullCardLogout() {
            const ucard = await UCard.getUCard();
            ucard.setOnPullCard(() => {
                this.$message.error({
                    message: 'U盾被拔出，即将退出登录',
                    onClose: () => {
                        authHelper.handleLogout();
                    },
                });
            });
        }
    },
};
